import api, { apiOld } from './api';
import { API_ENDPOINTS } from './endpoints';

// Serviço para Authenticação (User)
export const authService = {
    // Login
    login: (email: string, password: string) =>
        api.post(API_ENDPOINTS.AUTH.LOGIN, { email, password }),

    // Registro
    // register: (userData: any) =>
    //     api.post(API_ENDPOINTS.AUTH.REGISTER, userData),

    // Logout
    logout: () => api.post(API_ENDPOINTS.AUTH.LOGOUT),

    // Obter perfil do usuário
    getProfile: () => api.get(API_ENDPOINTS.AUTH.PROFILE),

    // Atualizar perfil do usuário
    updateProfile: (userData: any) =>
        api.put(API_ENDPOINTS.AUTH.PROFILE, userData),

    // Alterar senha
    changePassword: (passwordData: any) =>
        api.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, passwordData),

    oldAPIInitSession: (token: string) => apiOld.post(API_ENDPOINTS.AUTH.OLD_API_INIT_SESSION, { 'token': token }),
}